export var fontFamily = {
    body: [
        "Soehne",
        "Helvetica",
        "Segoe UI",
        "sans-serif"
    ],
    heading: [
        "Soehne",
        "Helvetica",
        "Segoe UI",
        "sans-serif"
    ]
};

//# sourceMappingURL=fontFamily.js.map